module.exports = __webpack_public_path__ + "img/other.afa906c9.svg";